import { TriangleAlertIcon } from "lucide-react";

import { cn } from "@/libs/cn";

import Button from "../Button";
import { Modal, ModalFooter } from "../Modal";

interface DeleteModalProps {
  open: boolean;
  title: string;
  description?: string;
  warning?: string;
  confirmText?: string;
  className?: string;
  loading?: boolean;
  onClose: () => void;
  onDelete: () => void;
}

const DeleteModal = ({
  open,
  title,
  description = "Tem certeza que deseja excluir?",
  warning,
  confirmText = "Excluir",
  className,
  loading,
  onClose,
  onDelete,
}: DeleteModalProps) => (
  <Modal
    open={open}
    onOpenChange={(next) => {
      if (!next && !loading) onClose();
    }}
    title={title}
    className={cn("max-w-120", className)}
  >
    <div className="mt-3 flex flex-col gap-4">
      <p className="text-[15px] leading-relaxed text-ui-text-dark">{description}</p>

      {warning && (
        <div className="flex items-start gap-3 rounded-lg border border-[#E5A000]/30 bg-[#FFF7E0] px-4 py-3.5">
          <TriangleAlertIcon className="mt-px shrink-0 text-[#E5A000]" size={20} />
          <p className="text-[13px] leading-relaxed text-ui-primary">{warning}</p>
        </div>
      )}
    </div>

    <ModalFooter className="mt-8">
      <Button label="Cancelar" variant="outlined" onClick={onClose} className="flex-1" disabled={loading} />
      <Button label={confirmText} color="danger" onClick={onDelete} className="flex-1" loading={loading} />
    </ModalFooter>
  </Modal>
);

export default DeleteModal;
